import { useMemo } from "react";

import { isEqual } from "lodash-es";

import { Schema } from "src/api/flowTypes";
import { MergeView } from "src/base-components/CodeInput/MergeView";
import { DiffViewContext } from "src/changeHistory/DiffViewModal/DiffViewContext";
import { DiffRevisionProps } from "src/changeHistory/DiffViewModal/DiffViewModal";
import { SchemaOptions } from "src/router/SearchParams";
import { stringifySchema } from "src/schema/window/utils";

type PossibleSchemaTyping = Schema | object | undefined;

export const JsonSchemaDiffView: React.FC<DiffRevisionProps> = ({
  change,
  previouseRevision,
}) => {
  const [modified, original] = useMemo(() => {
    const schemaType = change?.diff?.output_schema
      ? SchemaOptions.Output
      : SchemaOptions.Input;
    const originalSchema =
      schemaType === SchemaOptions.Output
        ? (previouseRevision.output_schema as PossibleSchemaTyping)
        : (previouseRevision.input_schema as PossibleSchemaTyping);
    const changedSchema =
      schemaType === SchemaOptions.Output
        ? (change?.diff?.output_schema as PossibleSchemaTyping)
        : (change?.diff?.input_schema as PossibleSchemaTyping);

    const originalSchemaStrict =
      !originalSchema || isEqual(originalSchema, {})
        ? undefined
        : (originalSchema as Schema);

    const changedSchemaStrict =
      !changedSchema || isEqual(changedSchema, {})
        ? undefined
        : (changedSchema as Schema);

    return [
      stringifySchema(changedSchemaStrict),
      stringifySchema(originalSchemaStrict),
    ];
  }, [change, previouseRevision]);

  return (
    <DiffViewContext
      value={{
        renderedInDiffView: true,
      }}
    >
      <MergeView
        dataLoc="schema-diff-view-json"
        modified={modified}
        original={original}
      />
    </DiffViewContext>
  );
};
